/* eslint-disable */
export default {
  infoMessageMins:
    'Salvataggio automatico del registro entro {delayTime} minuti...',
  infoMessageMin:
    'Salvataggio automatico del registro entro {delayTime} minuto...',
  infoMessageSecs:
    'Salvataggio automatico del registro entro {delayTime} secondi...',
  infoMessageSec:
    'Salvataggio automatico del registro entro {delayTime} secondo...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
